export default __webpack_public_path__ + "static/media/Rectangle 1036.30c48f62.png";